import React, { useRef } from 'react';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import logo from '../../assets/img/Sculpt-logo.png';
import { useDispatch, useSelector } from 'react-redux';
import { downloadVoucher, voucherData } from '../../redux/actions/Account.action';
import { appointementGetById } from '../../redux/actions/Files.action';

const Index = ({ billRef, allData, voucherId }) => {

    const { id } = useParams()
    const voucherId2 = localStorage.getItem('voucherId')
    console.log("voucherId", voucherId2);
    const dispatch = useDispatch();
    const branchData = useSelector((state) => state.files)
    const billData = useSelector((state) => state.account)
    console.log("billData", billData);
    const userId = branchData?.getAppointmentById?.data?.appointmentData?.patientId;
    const patientDetails = billData?.downloadVoucher?.data?.patientDetails;
    console.log("patientDetails", patientDetails);
    const voucherDatas = billData?.downloadVoucher?.data?.data
    console.log("voucherDatas", voucherDatas);
    console.log("allData", allData);
    // const downloadPdf = () => {

    //     html2canvas(billRef.current, { scale: 2 }).then(canvas => {
    //         const imgData = canvas.toDataURL('image/png');
    //         const pdf = new jsPDF('p', 'mm', 'a4');

    //         const pageWidth = pdf.internal.pageSize.getWidth();
    //         const pageHeight = pdf.internal.pageSize.getHeight();

    //         const imgWidth = canvas.width * 210 / canvas.width;
    //         const imgHeight = (canvas.height * imgWidth) / canvas.width;


    //         let position = 0;
    //         if (imgHeight > pageHeight) {
    //             const heightLeft = imgHeight;
    //             const totalPages = Math.ceil(heightLeft / pageHeight);

    //             for (let i = 0; i < totalPages; i++) {
    //                 pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    //                 position -= pageHeight;
    //             }
    //         } else {
    //             pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
    //         }

    //         pdf.save('voucher.pdf');
    //     });
    // };

    useEffect(() => {
        dispatch(voucherData(userId))
        dispatch(downloadVoucher(userId, voucherId2))
        if (id) {
            dispatch(appointementGetById(id))
        }
    }, [id, userId])
    console.log("+++++++++", voucherId2);

    return (
        <div>
            {/* <div className='text-center'>
                <button onClick={downloadPdf} className='px-4 py-2 bg-theme-dark text-white my-3 rounded-lg'>Download</button>
            </div> */}

            <div
                ref={billRef}
                style={{
                    fontFamily: "Arial, sans-serif",
                    backgroundColor: "#fff",
                    width: '100%',
                    maxWidth: '595pt',
                    minHeight: "842pt",
                    overflow: 'hidden',
                    boxSizing: 'border-box',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    margin: 'auto'
                }}
            >
                <div
                    style={{
                        width: "100%",
                        height: "100px",
                        borderBottom: "1px solid #A0AEC0",
                        paddingBottom: "10px",
                        padding: "10mm",
                    }}
                >
                    <div style={{ marginBottom: "10px" }}>
                        <img src={logo} alt="Sculpt logo" style={{ height: "100px" }} />
                    </div>
                </div>

                <div
                    style={{
                        flex: '1',
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "20px",
                        padding: "10mm",
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            paddingLeft: "10px",
                            fontSize: "12px",
                        }}
                    >
                        <p><strong>Branch :</strong> {patientDetails?.branch}</p>
                        <p><strong>Address :</strong> {branchData?.getAppointmentById?.data?.appointmentData?.branchAddress}</p>
                        <hr style={{ color: "#b78234", fontWeight: "bold" }} />
                        <p><strong>Dr. Name :</strong> {patientDetails?.doctorName}</p>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <div>
                                <p><strong>Patient Name: </strong> {patientDetails?.firstName} {patientDetails?.lastName}</p>
                                <p><strong>State :</strong> {patientDetails?.state || ' - '}</p>
                                <p><strong>Ref By :</strong> {patientDetails?.reference[0]?.doctorDetail || patientDetails?.reference[0]?.personDetail || ' - '}</p>
                            </div>
                            <div>
                                <p><strong>Sex :</strong> {patientDetails?.gender}</p>
                                <p><strong>Contact No :</strong> {patientDetails?.phoneNumber}</p>
                                <p><strong>GST No :</strong> Dr. shah</p>
                            </div>
                            <div>
                                {/* <p><strong>Voucher Number :</strong> {voucherId}</p> */}
                                {/* <p><strong>Voucher Date :</strong> {new Date().toLocaleDateString()}</p> */}
                            </div>
                        </div>
                        <hr style={{ color: "#d68000", fontWeight: "bold" }} />

                        <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px', textAlign: 'center', fontSize:"14px" }}>
                            <thead>
                                <tr>
                                    <th style={{ border: '1px solid gray', padding: '8px' }}>SR. NO</th>
                                    <th style={{ border: '1px solid gray', padding: '8px' }}>Bill NO</th>
                                    <th style={{ border: '1px solid gray', padding: '8px' }}>Treatment Name</th>
                                    <th style={{ border: '1px solid gray', padding: '8px' }}>Total Seating</th>
                                    <th style={{ border: '1px solid gray', padding: '8px' }}>Booked Seating</th>
                                    <th style={{ border: '1px solid gray', padding: '8px' }}>Pending Seating</th>
                                    <th style={{ border: '1px solid gray', padding: '8px' }}>HSN/ Code</th>
                                </tr>
                            </thead>
                            <tbody>
                                {voucherDatas?.map((voucher, voucherIndex) =>
                                    voucher.services.map((service, serviceIndex) => (
                                        <tr key={`${voucherIndex}-${serviceIndex}`}>
                                            <td style={{ border: '1px solid gray', padding: '8px' }}>{serviceIndex + 1}</td>
                                            <td style={{ border: '1px solid gray', padding: '8px' }}>{service?.billNumber}</td>
                                            <td style={{ border: '1px solid gray', padding: '8px' }}>{service?.packageName}</td>
                                            <td style={{ border: '1px solid gray', padding: '8px' }}>{service?.seating}</td>
                                            <td style={{ border: '1px solid gray', padding: '8px' }}>{service?.bookedSeating}</td>
                                            <td style={{ border: '1px solid gray', padding: '8px' }}>{service?.pendingSeating}</td>
                                            <td style={{ border: '1px solid gray', padding: '8px' }}>9993</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>


                        </table>

                        <div style={{ marginTop: '20px' }}>
                            <p><strong>Operator :</strong> {billData?.downloadVoucher?.data?.authName}</p>
                        </div>
                    </div>
                </div>


                <div
                    style={{
                        position: 'fixed',
                        bottom: '0',
                        width: "100%",
                        borderTop: "5px solid #f2c07b",
                        backgroundColor: '#b78234',
                        paddingLeft: "10px",
                        paddingRight: '10px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        paddingBottom: "10px",
                        boxSizing: 'border-box',
                    }}
                >
                    <div style={{ marginTop: '10px' }}>
                        <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#f0cf9b' }}>Sculpt Skin Care</span>
                        <p style={{ fontSize: '12px', fontWeight: 'bold', color: 'white', width: "300px" }}>
                            503, Swastik House, Kargil Chowk, Nr. Shardayatan School, Piplod, Surat, Gujarat 395007
                        </p>
                    </div>
                    <div style={{ marginTop: '15px', display: "grid" }}>
                        <p style={{ fontSize: "12px", color: "white", display: "flex", marginBottom: "0px" }}>
                            <span style={{ fontSize: '12px', fontWeight: 'bold', color: '#f0cf9b' }}>CALL:</span> +91 75750 96668
                        </p>
                        <p style={{ fontSize: "12px", color: "white", display: "flex", marginBottom: "20px" }}>
                            <span style={{ fontSize: '12px', fontWeight: 'bold', color: '#f0cf9b' }}>WEBSITE:</span> sculptskincare.in
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Index
